<template>
	<div class="right_body action_body">
		<span class="btn right_sub_btn save_btn" @click="submitData" :isDisable="isDisable">提交数据</span>
    <el-tabs v-model="activeName" v-loading="$store.state.isLoading">

    	<el-tab-pane label="供应商信息" name="base">
        <el-form ref="baseForm" :rules="rules" :model="fromData">
            <div class="coll">
              <h2 class="title"><span>基本信息</span></h2>
              <div class="from_box flex">
                <div class="item" v-if="isEdit">
                  <span class="txt">供应商编号：</span>
                  <el-input
                  v-model="fromData.supplierCode"
                  maxlength="8"
                  :disabled="isEdit"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  autocomplete="off" placeholder="请输入"></el-input>
                </div>
                <el-form-item class="item" label="供应商描述：" prop="supplierName">
                  <el-input v-model="fromData.supplierName"
                  maxlength="40" show-word-limit
                  autocomplete="off" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item class="item" label="供应商分类：" prop="subjectGroupId">
                  <el-select filterable v-model="fromData.subjectGroupId" @change="changeGroup" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in group"
                      :key="item.index"
                      :label="item.subjectGroupDesc"
                      :value="item.subjectGroupId"
                      >
                    </el-option>
                  </el-select>
                </el-form-item>
                <!-- <div class="item">
                  <span class="txt">客户编码：</span>
                  <el-input v-model="fromData.customerCode" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off" placeholder="请输入"></el-input>
                </div> -->
              </div>
            </div>
            <div class="coll">
              <h2 class="title"><span>联系人</span></h2>
              <div class="from_box flex">
                <el-form-item class="item" label="联系人：" prop="contact">
                  <el-input
                    type="text"
                    :placeholder="$store.state.remark.contact"
                    v-model="fromData.contact"
                  ></el-input>
                </el-form-item>
                <el-form-item class="item" label="电子邮件：" prop="email">
                  <el-input
                    type="text"
                    :placeholder="$store.state.remark.email"
                    v-model="fromData.email"
                  ></el-input>
                </el-form-item>
                <el-form-item class="item" label="固定电话：" prop="workPhone">
                  <el-input
                    type="text"
                    :placeholder="$store.state.remark.tel"
                    v-model="fromData.workPhone"
                    maxlength="13"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item class="item" label="联系手机：" prop="telephone">
                  <el-input
                    type="text"
                    :placeholder="$store.state.remark.mob"
                    v-model="fromData.telephone"
                    maxlength="11"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <div class="item">
                    <span class="txt">微信：</span>
                    <el-input v-model="fromData.weCat" autocomplete="off" placeholder="请输入"></el-input>
                  </div>
                  <div class="item">
                    <span class="txt">省：</span>
                    <el-input v-model="fromData.proviceDesc" autocomplete="off" placeholder="请输入"></el-input>
                  </div>
                  <div class="item">
                    <span class="txt">市：</span>
                    <el-input v-model="fromData.cityDesc" autocomplete="off" placeholder="请输入"></el-input>
                  </div> 
                  <div class="item">
                    <span class="txt">县：</span>
                    <el-input v-model="fromData.countyDesc" autocomplete="off" placeholder="请输入"></el-input>
                  </div>
              </div>
            </div>
            <div class="coll">
              <h2 class="title"><span>地址</span></h2>
              <div class="from_box flex">
                <div class="item">
                  <span class="txt">国家代码：</span>
                  <el-select filterable @change="changContryKeyValue" v-model="fromData.countryCode" placeholder="请选择">
                    <el-option
                      v-for="(item,index) in cities"
                      :key="item.index"
                      :label="item.zh"
                      :value="item.locale"
                      >
                      <span style="float: left">{{ item.locale}}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.zh}}</span>
                    </el-option>
                  </el-select>
                </div>
                <el-form-item class="item" label="所在地区：" prop="area">
                  <el-input v-model="fromData.area" autocomplete="off" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item class="item" label="详细地址：" prop="streetAddress">
                  <el-input v-model="fromData.streetAddress" autocomplete="off" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item class="item" label="邮编：" prop="cityZipCode">
                  <el-input v-model="fromData.cityZipCode"
                  maxlength="8" show-word-limit
                  oninput="value=value.replace(/[^\d]/g,'')"
                  autocomplete="off" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="coll">
              <h2 class="title"><span>其他信息</span></h2>
              <div class="from_box flex">
                <el-form-item class="item" label="增值税登记号：" prop="vatRegiNum">
                  <el-input v-model="fromData.vatRegiNum" autocomplete="off" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
            </div>

            <div class="coll">
              <h2 class="title"><span>供应商评级</span></h2>
              <div class="from_box flex">
                <div class="item">
                  <span class="txt">供应商评分：</span>
                  <v-star ref="star" :rating="fromData.creditRating" @changeStar="changeStar" style="padding-top:3px;"></v-star>
                </div>
                <div class="item" style="padding-top:8px;">
                	<el-checkbox @change="changeBlack" v-model="isBlack">供应商黑名单</el-checkbox>
                </div>
              </div>
            </div>
        </el-form>


      </el-tab-pane>
      <el-tab-pane label="银行卡信息" name="bank">
        <div class="coll" style="width: 100%;">
          <vxe-table
            border
            :data="banks"
            :edit-config="{trigger: 'click', mode: 'cell'}"
            @edit-actived="editActivedEvent"
            @edit-closed="editClosedEvent">
            <!-- <vxe-table-column field="name" title="银行卡号" :edit-render="{name: 'number'}"></vxe-table-column>
            <vxe-table-column field="role" title="开户银行" :edit-render="{name: 'select', options: selectBankList}"></vxe-table-column>
            <vxe-table-column field="sex" title="开户支行" :edit-render="{name: 'input'}"></vxe-table-column>
            <vxe-table-column field="num6" title="持有人" :edit-render="{name: 'input', attrs: {type: 'number'}}"></vxe-table-column> -->

            <!-- <vxe-table-column field="bankName" title="银行名称" :edit-render="{name: 'input'}"></vxe-table-column>
            <vxe-table-column field="bank" title="开户行" :edit-render="{name: 'input'}"></vxe-table-column>
            <vxe-table-column field="countryCode" title="银行国家代码" :edit-render="{name: 'input'}"></vxe-table-column>
            <vxe-table-column field="bankAccountNumber" title="银行账户号码" :edit-render="{name: 'number'}"></vxe-table-column>
            <vxe-table-column field="accountHoldName" title="账户持有人姓名" :edit-render="{name: 'input'}"></vxe-table-column>
            <vxe-table-column field="cityZipCode" title="城市邮政编码" :edit-render="{name: 'input'}"></vxe-table-column>
            <vxe-table-column field="telephone" title="电话号码" :edit-render="{name: 'input'}"></vxe-table-column>
            <vxe-table-column field="bankAddress" title="地址" :edit-render="{name: 'input'}"></vxe-table-column> -->
          </vxe-table>
        </div>

        <!-- <el-form ref="baseForm" :rules="rules" :model="fromData">
          <div class="coll">
            <div class="from_box flex">
              <div class="item">
                <span class="txt">银行名称：</span>
                <el-input v-model="fromData.bankName" autocomplete="off" placeholder="请输入"></el-input>
              </div>
              <div class="item">
                <span class="txt">开户支行：</span>
                <el-input v-model="fromData.bankAddress" autocomplete="off" placeholder="请输入"></el-input>
              </div>
              <div class="item">
                <span class="txt">银行卡卡号：</span>
                <el-input v-model="fromData.bankAccountNumber" autocomplete="off" placeholder="请输入"></el-input>
              </div>
              <div class="item">
                <span class="txt">持有人：</span>
                <el-input v-model="fromData.accountHoldName" autocomplete="off" placeholder="请输入"></el-input>
              </div>
            </div>
          </div>
        </el-form> -->
      </el-tab-pane>
    </el-tabs >
	</div>
</template>

<script>
import {suplierApi} from 'api/base.js';
import countryCode from 'mock/countryCode.json'
import areaJson from 'mock/area.json'
import vStar from 'components/common/star.vue';

import bankList from 'components/table/vxeTab.vue';
import {mapState,mapActions} from 'vuex';

export default {
	components:{
    vStar
	},
  data() {
    return {
      cities:countryCode,
      areaData:areaJson,
      isDisable:false,
      id:'',
      isEdit:false,
      activeName: 'base',
      isBlack:false,//是否黑名单
      selectArea:[],
      banks:[],//银行卡列表
      selectBankList:[{}],
      fromData:{
        "countryCode":'CN',//国家地区默认中国
      },
      group:[],//供应商组
      columns:[
        {field:"bankName",title:"银行名称"},
        {field:"bank",title:"开户行"},
        {field:"bankAddress",title:"银行国家代码"},
        {field:"bankAccountNumber",title:"银行账户号码"},
        {field:"accountHoldName",title:"账户持有人姓名"},
        {field:"cityZipCode",title:"城市邮政编码"},
        {field:" telephone",title:"电话号码"},
        {field:" bankAddress",title:"地址"}
      ],//银行卡表头
      rules: {
        email:[{
          required: true,
          pattern:/^[A-Za-z0-9\u4e00-\u9fa5.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          message: "请输入正确的邮箱格式",trigger: "blur"
        }],
        telephone:[{
          required: true,
          pattern:/^1[3456789]\d{9}$/,
          message: "请输入正确的手机格式",trigger: "blur"
        }],
        workPhone:[{
          required: true,
          pattern:/0\d{2,3}-\d{7,8}/,
          message: "请输入正确的固话格式(比如：0379-63237856)",trigger: "blur"
        }],
        supplierName:[{
          required: true,
          message: "请输入供应商描述",trigger: "blur"
        }],
        contact:[{
          required: true,
          message: "请输入联系人",trigger: "blur"
        }],
        subjectGroupId:[{
          required: true,
          message: "请选择供应商分类",trigger: "blur"
        }],
        area:[{
          required: true,
          message: "请输入所在地区",trigger: "blur"
        }],
        streetAddress:[{
          required: true,
          message: "请输入详细地址",trigger: "blur"
        }],
        cityZipCode:[{
          required: true,
          message: "请选择正确的邮编格式",trigger: "blur"
        }],
        vatRegiNum:[{
          required: true,
          message: "请输入增值税登记号",trigger: "blur"
        }]
      }
    };
  },
	created(){
		this.areaData.forEach((v,k)=>{
			if(!v.children){
				delete v.children
			}
		});
    this.getInitData();
	},
	methods: {    
    //获取初始数据
    getInitData(){
      //供应商
      this.getGroup();
      //当前需要修改的数据
      this.getInfo();
    },
    //银行卡列表
    getBankList(){

    },
    //获取供应商组
    async getGroup(){
      let res = await this.$post(suplierApi.group,this.$store.state.getAllPage);
      if(res.status && res.data){
        this.group = res.data.list;
      }else{
        this.group = [];
      }
    },
		//获取国家代码
		changContryKeyValue(item){
      console.log(item);
		},
    //改变组
    changeGroup(val){
      let obj = this.group.find(v=>v.subjectGroupId === val);
      if(obj){
        this.fromData.subjectGroupId = obj.subjectGroupId;
        this.fromData.subjectGroup = obj.subjectGroup;
        this.fromData.subjectGroupDesc = obj.subjectGroupDesc;
      }
    },
		//获取当前的数据
		async getInfo(){
			let id = this.$route.params.id;
			if(id){
				let res = await this.$get(suplierApi.find,{'supplierId':id});
				const {data,msg,msgCode} = res;
				this.selectArea = [data.proviceCode,data.cityCode,data.countyCode];
				if(data){
          this.isEdit = true;
					this.fromData = data;
          if(this.fromData.creditRating){
            this.fromData.creditRating = parseInt(this.fromData.creditRating);
            if(data.blacklist == 1){
              this.isBlack = true;
            }
            this.$refs.star.posStar(this.fromData.creditRating);
          }else{
            this.fromData.creditRating = 0;
            // this.$refs.star.posStar(this.fromData.creditRating);
          }
				}
			}
    },
    validataForm(){
      this.$refs['baseForm'].validate((vaild)=>{
        this.regRes = vaild;
      });
    },
		//提交数据
		async submitData(){
      let vm = this;
			let id = this.$route.params.id;
			var postUrl = suplierApi.add;
      if(id) postUrl = suplierApi.edit;

      this.validataForm();
      let baseRes = this.regRes;
      if(!baseRes) return;

      // if(!this.fromData.supplierName){ 
      //   this.$message.error('请选择供应商描述');
      //   return false;
      // }
      // if(!this.fromData.subjectGroupId){ 
      //   this.$message.error('请选择供应商分类');
      //   return false;
      // }
      // if(!this.fromData.contact){ 
      //   this.$message.error('请选择联系人');
      //   return false;
      // }
      // if(!this.fromData.email){ 
      //   this.$message.error('请选择电子邮件');
      //   return false;
      // }
      // if(!this.fromData.workPhone){ 
      //   this.$message.error('请选择联系电话');
      //   return false;
      // }
      // if(!this.fromData.telephone){ 
      //   this.$message.error('请选择联系手机');
      //   return false;
      // }
      // if(!this.fromData.area){ 
      //   this.$message.error('请选择所在地区');
      //   return false;
      // }
      // if(!this.fromData.streetAddress){ 
      //   this.$message.error('请选择详细地址');
      //   return false;
      // }
      // if(!this.fromData.cityZipCode){ 
      //   this.$message.error('请选择邮编');
      //   return false;
      // }
      // if(!this.fromData.vatRegiNum){ 
      //   this.$message.error('请选择增值税号');
      //   return false;
      // }
      this.isDisable = true;

			console.log(JSON.stringify(this.fromData));
			let res = await this.$post(postUrl,this.fromData);

      this.isDisable = false;
      if(res.status){
        let successMsg = id ? "供应商 "+res.data.supplierCode + " 修改成功" : "供应商"+res.data.supplierCode + "创建成功";
        this.$alert(successMsg,"操作提示", {
          confirmButtonText: '确定',
          callback: action => {
           vm.fromData = {};
           vm.$router.push({name:'base-supplier-list'});
          }
        });
        //this.$router.push({name:'base-supplier-detail',params:{id:res.data.supplierId}});
        //this.$router.push({name: 'base-matter-detail', params: {id:res.data.materialId}});
      }else{
        this.$message.error(res.errorMsg);
      }
		},
    //黑名单
    changeBlack(val){
    	if(val){
    		this.fromData.blacklist = 1;
    	}else{
    		this.fromData.blacklist = 0;
    	}
    },
    //改变星级
    changeStar(level){
      this.fromData.creditRating = level;
    },
    editActivedEvent ({ row, column }, event) {
      console.log(`打开 ${column.title} 列编辑`)
    },
    editClosedEvent ({ row, column }, event) {
      console.log(`关闭 ${column.title} 列编辑`)
    }
  }
};
</script>

<style lang="stylus" scoped>

</style>
